module.exports = __webpack_public_path__ + "img/logo-loader.73d4f82c.png";